import React from 'react';
import { Switch, Route } from 'react-router-dom';

import {
  GatesInvoiceScreen,
  GatesInvoiceUpdateScreen,
  GatesTransferredInvoiceScreen,
  GatesUBFDraftScreen,
} from './index';

const gatesRoutes = {
  gatesFatura: GatesInvoiceScreen,
  gatesFaturaDuzenle: GatesInvoiceUpdateScreen,
  gatesFaturaAktarilan: GatesTransferredInvoiceScreen,
  gatesUbf: GatesUBFDraftScreen,
};

const GatesRoutes = ({ menu }) => {
  return (
    <Switch>
      {/** Burada children menüye göre düzenleme yapılacak  */}
      {/** Menüde görünen routeları render etmektedir.  */}
      {menu.map(({ id, link, key }) => {
        return (
          <Route key={id} path={link} component={gatesRoutes[key]} exact />
        );
      })}
      {/**  Child Routeları render etmektedir.Menude listelenmemektedir. */}
      {menu.map(({ childRoute }) => {
        return (
          childRoute.length !== 0 &&
          childRoute.map(({ id, link, key }) => {
            return (
              <Route key={id} path={link} component={gatesRoutes[key]} exact />
            );
          })
        );
      })}
    </Switch>
  );
};

export default GatesRoutes;
